import BaseController from "./BaseController";
import Event from "sap/ui/base/Event";
import EventBus from "sap/ui/core/EventBus";
import NotificationListItem from "sap/m/NotificationListItem";

/**
 * @namespace com.ang.portal.controller
 */
export default class Notifications extends BaseController {
	public refreshPage(): void {
		this.publish("Refresh");
	}

	public onRefresh(): void {
		this.publish("Refresh");
	}

	public onMarkAllRead(): void {
		this.publish("MarkAllRead");
	}

	public onNotificationPress(oEvent: Event): void {
		const listItem = oEvent.getParameter("listItem" as never) as
			| NotificationListItem
			| undefined;
		const source = oEvent.getSource() as {
			getBindingContext?: (name: string) => unknown;
		};
		const context =
			listItem?.getBindingContext("home") ?? source.getBindingContext?.("home");
		const entry = (
			context as { getObject?: () => unknown } | undefined
		)?.getObject?.();

		if (entry && typeof entry === "object") {
			this.publish("Open", entry);
		}
	}

	public onNotificationMarkUnread(oEvent: Event): void {
		const entry = this.getEntryFromEvent(oEvent);
		if (entry) {
			this.publish("MarkUnread", entry);
		}
	}

	public onNotificationDelete(oEvent: Event): void {
		const entry = this.getEntryFromEvent(oEvent);
		if (entry) {
			this.publish("Delete", entry);
		}
	}

	private getEntryFromEvent(oEvent: Event): object | undefined {
		const source = oEvent.getSource() as {
			getBindingContext?: (name: string) => unknown;
		};
		const context = source.getBindingContext?.("home");
		const entry = (
			context as { getObject?: () => unknown } | undefined
		)?.getObject?.();
		return entry && typeof entry === "object" ? entry : undefined;
	}

	private publish(eventName: string, data: object = {}): void {
		EventBus.getInstance().publish("NotificationsChannel", eventName, data);
	}
}
